<script>
  import { Flex, FlexItem, Button, SimpleDataTable, DataCell, Icon, Text } from "@gl/design-system"
  import { _, user } from "../../stores/index"
  import { navigate } from "svelte-routing"
  import { onMount } from "svelte"
  import { ContractsRepository } from "../../repositories"
  import { faPlus, faTrashAlt } from "@fortawesome/pro-regular-svg-icons"
  import { ConfirmModal, ContractModal } from "../../components/index"
  import Layout from "../../components/Layout.svelte"
  let loading = {}

  let contracts = []

  let modal
  let confirmModal
  let selectedCon

  async function fetchContracts() {
    loading.contracts = true
    try {
      const result = await ContractsRepository.getContracts()
      console.log("🚀 ~ fetchContracts ~ result:", result)
      contracts = result.list
    } finally {
      loading.contracts = false
    }
  }

  async function handleDelete() {
    loading.delete = true
    try {
      await ContractsRepository.deleteContract(selectedCon.id)
    } finally {
      fetchContracts()
      loading.delete = false
    }
  }

  onMount(() => {
    fetchContracts()
    if (!$user.data.isMaster) {
      navigate("/forbidden")
    }
  })
</script>

{#if modal}
  <ContractModal
    bind:active={modal}
    on:close={() => {
      modal = false
    }}
    on:success={() => {
      modal = false
      fetchContracts()
    }}
  />
{/if}

{#if confirmModal}
  <ConfirmModal
    bind:active={confirmModal}
    on:close={() => {
      confirmModal = false
      selectedCon = null
    }}
    handleYes={handleDelete}
    title={$_("cons.delete")}
    confirmationValue={selectedCon.id}
  >
    <p>{$_("cons.delete.warning1")}<b>{selectedCon.name}</b> ?</p>
    <p>{$_("cons.delete.warning2")}</p>

    <p class="mt-4 mb-2">
      {$_("cons.delete.warning.confirmation1")}
      <b>{selectedCon.id}</b>
      {$_("cons.delete.warning.confirmation2")}
    </p>
  </ConfirmModal>
{/if}

<Layout selected="contracts">
  <Flex class="mb-5">
    <FlexItem>
      <h3 class="level-3 gl-title">{$_("common.contracts")}</h3>
    </FlexItem>

    <FlexItem pushEnd>
      <Button
        on:click={() => {
          modal = true
        }}
      >
        <Icon icon={faPlus} />
        <Text>{$_("contracts.add")}</Text>
      </Button>
    </FlexItem>
  </Flex>

  <div class="table-container">
    <SimpleDataTable
      let:index
      let:row
      data={contracts}
      fullWidth
      selectable={false}
      variant="separate"
      loading={loading.contracts}
      stickyHead
    >
      <DataCell {index} id={`${row.id}-id`} header="ID">
        {row.id}
      </DataCell>

      <DataCell {index} header={$_("common.name")} id={`${row.id}-name`}>
        {row.name}
      </DataCell>

      <DataCell {index} header={$_("common.customer")} id={`${row.id}-customer`}>
        {row.customer.name}
      </DataCell>

      <DataCell {index} header={$_("common.authorizer")} id={`${row.id}-customer`}>
        {row.authorizer.name}
      </DataCell>

      <DataCell {index} header="">
        <Button
          outlined
          size="tiny"
          status="error"
          on:click={() => {
            selectedCon = row
            confirmModal = true
          }}
        >
          <Icon icon={faTrashAlt} />
          <Text>{$_("buttons.delete")}</Text>
        </Button>
      </DataCell>
    </SimpleDataTable>
  </div>
</Layout>
